import React, { createContext, useContext, useState, useCallback } from 'react';

const AdvertDetailModalContext = createContext(null);

export function AdvertDetailModalProvider({ children }) {
    const [selectedAdvertId, setSelectedAdvertId] = useState(null);

    const openAdvert = useCallback((id) => {
        setSelectedAdvertId(id);
    }, []);

    const closeAdvert = useCallback(() => {
        setSelectedAdvertId(null);
    }, []);

    return (
        <AdvertDetailModalContext.Provider value={{ selectedAdvertId, openAdvert, closeAdvert }}>
            {children}
        </AdvertDetailModalContext.Provider>
    );
}

export function useAdvertDetailModal() {
    const context = useContext(AdvertDetailModalContext);
    if (!context) {
        console.warn('useAdvertDetailModal must be used within an AdvertDetailModalProvider');
        return {
            selectedAdvertId: null,
            openAdvert: () => {},
            closeAdvert: () => {},
        };
    }
    return context;
}